// Lib
import React, { createContext } from 'react';
import { Provider } from 'react-redux';

export const LiveCollaborationStoreContext = createContext();

export const LiveCollaborationStoreProvider = (props) => (
    <Provider context={LiveCollaborationStoreContext} {...props} />
);
